export default function LeaveInfoIcon() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 19.25H17.5M5.80905 19.2504C4.37372 18.5915 3.15763 17.5346 2.30519 16.205C1.45274 14.8755 0.999745 13.3293 1 11.75V7.25H17.5M17.5 7.25V11.75C17.5003 13.3293 17.0473 14.8756 16.1948 16.2051C15.3423 17.5346 14.1262 18.5915 12.6909 19.2504M17.5 7.25C18.2956 7.25 19.0587 7.56607 19.6213 8.12868C20.1839 8.69129 20.5 9.45435 20.5 10.25V11C20.5 11.7956 20.1839 12.5587 19.6213 13.1213C19.0587 13.6839 18.2956 14 17.5 14H17.1833M12.25 1.25V4.25M9.25 1.25V4.25M6.25 1.25V4.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
